import Title from '../elements/Title';

const ResumeLanding = () => (
    <div className='h-full' id='landing'>
        <div className='h-full flex flex-col items-center justify-center'>
            <Title size={'xxxxl'} title={'Resume'} />
        </div>
    </div>
);

export default ResumeLanding;
